import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import { bounce_right_to_left_variants } from "shared/components/animations";
import giphyBanner from "assets/images/gah/giphy-banner.png";

const GiphyModal = ({ toggleGiphyModal }) => {
  return (
    <div className="giphy-modal-container">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={bounce_right_to_left_variants}
        className="giphy-modal-inner"
      >
        <img alt="" src={giphyBanner} />
        <div className="content-div">
          <p className="content-text">
            Images provided by{" "}
            <span
              className="highlighted"
              onClick={() => window.open("https://www.giphy.com")}
            >
              Giphy
            </span>
            .
          </p>
          <p className="content-text">
            All efforts are made to ensure proper usage and credit of all
            content within the GameApart platform. If you believe content is
            being used in error, please contact us at{" "}
            <span
              className="highlighted"
              // onClick={()=>window.open("https://www.giphy.com")}
            >
              ip@gameapart.com
            </span>
            .
          </p>

          <div className="border-line" />

          <p className="bottom-text">
            There is either no GIPHY content currently displayed, or no
            attribution data was provided back with the image.
          </p>
          <div className="close-button" onClick={toggleGiphyModal}>
            <h2 className="close-text">Close</h2>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default GiphyModal;
